import Vue from 'vue'
import VueRouter from 'vue-router'
// 导入登录和注册对应的路由组件
import DuLogin from '../components/DuLogin.vue'
import DuRegister from '../components/DuRegister.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: DuLogin
  },
  {
    path: '/register',
    name: 'register',
    component: DuRegister
  }
]

const router = new VueRouter({
  // mode: 'history', // 使用history模式
  linkActiveClass: 'my-active',
  linkExactActiveClass: 'my-exact-active',
  routes
})

export default router
